import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=60eeec14&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "@/static/css/complain_v2/create.css?vue&type=style&index=0&id=60eeec14&prod&lang=css&scoped=true&external"
import style1 from "./Create.vue?vue&type=style&index=1&id=60eeec14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eeec14",
  null
  
)

export default component.exports